<app-card *ngIf="hasPermissionReadCriteriaConsortium">
    <app-summary-award-program></app-summary-award-program>
</app-card>

<br>

<app-card *ngIf="hasPermissionSales" (click)="navigateToConsortiumSalesPanel()">
    <app-summary-sales></app-summary-sales>
</app-card>

<br>

<div class="cards-container mobile_cards-container">
    <app-card [full]="true" *ngIf="hasPermissionComissionReports" (click)="navigateToConsortiumReportsCommissions()">
        <app-summary-commission-reports></app-summary-commission-reports>
    </app-card>

    <app-card [full]="true" *ngIf="hasPermissionPortfolioManagement" (click)="navigateToConsortiumPortifolioManagement()">
        <app-summary-contemplated-quotas></app-summary-contemplated-quotas>
    </app-card>
</div>

<br>
